import React, { useState, useEffect } from "react";
import {
  UserIcon,
  UsersIcon,
  GlobeAltIcon,
  SunIcon,
  ArrowRightIcon,
  PlusIcon,
  MinusIcon,
  RocketLaunchIcon,
} from "@heroicons/react/24/outline";

import EtWabActionIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabActionIcon1SVGComp";
import EtWabReflectionIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabReflectionIcon1SVGComp";
import EtWabConversationIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabConversationIcon1SVGComp";
import EtWabCreationIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabCreationIcon1SVGComp";

import EtMagnetizationCollectiveIcon1SVGComp from "@/assets/img/icons/svgComp/EtMagnetizationCollectiveIcon1SVGComp";
import EtMagnetizationSelfIcon2SVGComp from "@/assets/img/icons/svgComp/EtMagnetizationSelfIcon2SVGComp";
import EtRoleCIsIcon1SVGComp from "@/assets/img/icons/svgComp/EtRoleCIsIcon1SVGComp";
import EtImprintMissionTeamIcon1SVGComp from "@/assets/img/icons/svgComp/EtImprintMissionTeamIcon1SVGComp";

import EtActionCollectiveIcon1SVGComp from "@/assets/img/icons/svgComp/EtActionCollectiveIcon1SVGComp";
import EtReflectionCollectiveIcon1SVGComp from "@/assets/img/icons/svgComp/EtReflectionCollectiveIcon1SVGComp";
import EtConversationCollectiveIcon1SVGComp from "@/assets/img/icons/svgComp/EtConversationCollectiveIcon1SVGComp";

import EtStartHereIconSVGComp from "@/assets/img/icons/svgComp/EtStartHereIconSVGComp";
import EtEtTrinityIcon6SVGComp from "@/assets/img/icons/svgComp/EtEtTrinityIcon6SVGComp";


import EtTrinityOnboardingWelcomeContent from "./EtTrinityOnboardingWelcomeContent";  // 11 Mar 2026
import EtTrinityOnboardingBeginContent from "./EtTrinityOnboardingBeginContent";      // 16 Mar 2026
import EtTrinityOnboardingUnlockSelf from "./EtTrinityOnboardingUnlockSelf";   // 31 Mar 2026
import EtTrinityOnboardingUnlockTeams from "./EtTrinityOnboardingUnlockTeams";   // 15 Apr 2026
import EtTrinityOnboardingUnlockBIC from "./EtTrinityOnboardingUnlockBIC";   // 20 Apr 2026


const EtTrinityPurposeNativeOnBoarding = ({ setActiveTopTab }) => {
  // Author - Atul Pandey
  // First Created - 07 Mar 2026
  // Purpose - to act as the onboarding page for Purpose Native Board Page
  // Updated - 07 Mar 2026 - Web: grid cards + detail panel, Mobile: accordion
  // Updated - 11 Mar 2026 - Componentization of sections - Welcome
  // Updated - 12 Mar 2026 - Copy refinements
  // Updated - 16 Mar 2026 - Componentization of sections - begin
  // Updated - 31 Mar 2026 - Componentization of sections - unlock self
  // Updated - 15 Apr 2026 - Componentization of sections - unlock team
  // Updated - 15 Apr 2026 - Copy refinement - title for universe board view
  // Updated - 20 Apr 2026 - Componentization of sections - unlock BIC (Best in class)
  // Updated - 20 Apr 2026 - Changed section name to unlockBIC from boardView for renderSectionContet()


  // 1️⃣ Responsive detection
  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 2️⃣ Mobile accordion state
  const [openSections, setOpenSections] = useState({
    welcome: true,
    begin: false,
    unlockSelf: false,
    unlockTeams: false,
    // boardView: false,
    unlockBIC: false,     // 20 Apr 2026
  });

  const toggleSection = (sectionKey) => {
    setOpenSections((prev) => ({
      ...prev,
      [sectionKey]: !prev[sectionKey],
    }));
  };

  // 3️⃣ Web selected section state
  const [selectedSection, setSelectedSection] = useState("welcome");

  // 4️⃣ Reusable data
  const startPoints = [
    {
      id: "morningHabits",
      title: "Morning Habits",
      desc: "Build your daily rhythm.",
      Icon: SunIcon,
    },
    {
      id: "reflections",
      title: "Reflections",
      desc: "Strengthen your thinking.",
      Icon: EtWabReflectionIcon1SVGComp,
    },
    {
      id: "actions",
      title: "Actions",
      desc: "Move your priorities forward.",
      Icon: EtWabActionIcon1SVGComp,
    },
    {
      id: "creations",
      title: "Creations",
      desc: "Capture and shape original output.",
      Icon: EtWabCreationIcon1SVGComp,
    },
  ];

  const unlockYourself = [
    {
      id: "routine",
      unlock: "Unlock Your Routine",
      area: "Morning Habits",
      Icon: SunIcon,
    },
    {
      id: "intellect",
      unlock: "Unlock Your Intellect",
      area: "Reflections",
      Icon: EtWabReflectionIcon1SVGComp,
    },
    {
      id: "creativeHorsepower",
      unlock: "Unlock Your Creative Horsepower",
      area: "Creations",
      Icon: EtWabCreationIcon1SVGComp,
    },
    {
      id: "presence",
      unlock: "Unlock Your Presence",
      area: "Conversations",
      Icon: EtWabConversationIcon1SVGComp,
    },
    {
      id: "perspectives",
      unlock: "Unlock Your Perspectives",
      area: "Induction",
      Icon: EtMagnetizationSelfIcon2SVGComp,
    },
  ];

  const unlockYourTeams = [
    {
      id: "teamInduction",
      title: "Induction for Teams",
      desc: "Shift how your teams think and engage.",
      Icon: EtMagnetizationCollectiveIcon1SVGComp,
    },
    {
      id: "collectiveActions",
      title: "Collective Actions",
      desc: "Move shared priorities forward.",
      Icon: EtActionCollectiveIcon1SVGComp,
    },
    {
      id: "missions",
      title: "Missions",
      desc: "Align effort to meaningful outcomes.",
      Icon: EtImprintMissionTeamIcon1SVGComp,
    },
    {
      id: "teamReflections",
      title: "Collective Reflections",
      desc: "Build clarity across the team.",
      Icon: EtReflectionCollectiveIcon1SVGComp,
    },
    {
      id: "teamCreations",
      title: "Collective Creations",
      desc: "Turn ideas into shared output.",
      Icon: EtRoleCIsIcon1SVGComp,
    },
    {
      id: "teamConversations",
      title: "Collective Conversations",
      desc: "Strengthen presence and connection.",
      Icon: EtConversationCollectiveIcon1SVGComp,
    },
  ];

  // 5️⃣ Top level onboarding cards for web
  const onboardingSections = [
    {
      id: "welcome",
      title: "Welcome to Trinity",
      // title: "The Trinity Approach",
      // desc: "Understand the Trinity approach.",
      desc: "What Trinity unlocks for you.",     // 12 Mar 2026
      Icon: EtEtTrinityIcon6SVGComp,
    },
    {
      id: "begin",
      title: "Where to Begin",
      // desc: "Start with habits and action.",
      desc: "Start building your growth muscles.",    // 12 Mar 2026
      // Icon: EtStartHereIconSVGComp,
      Icon: RocketLaunchIcon,
    },
    {
      id: "unlockSelf",
      title: "Unlock Yourself",
      desc: "Build your own growth.",
      Icon: UserIcon,
    },
    {
      id: "unlockTeams",
      title: "Unlock Your Teams",
      desc: "Elevate collective growth.",
      Icon: UsersIcon,
    },
    {
      // id: "boardView",                                       // 20 Apr 2026    
      id: "unlockBIC",
      title: "Become Best-in-class",                            // 15 Apr 2026       
      // title: "See Where You Stand",                               
      // title: "Decide your further unlocks",                   // 12 Mar 2026
      // desc: "Track Self, Collective, Universe.",
      desc: "Step up your unlocks to leap ahead.",      // 12 Mar 2026
      Icon: GlobeAltIcon,
    },
  ];

  // 6️⃣ Web detail panel content
  const renderSectionContent = () => {
    if (selectedSection === "welcome") {
        return <EtTrinityOnboardingWelcomeContent />;
    }

    // 16 Mar 2026
    if (selectedSection === "begin") {
        return <EtTrinityOnboardingBeginContent />;
    }

    // if (selectedSection === "begin") {
    //   return (
    //     <div>
    //       <p className="text-sm font-bold text-gray-800">Where to Begin</p>
    //       <p className="text-xs text-gray-600 mt-1">
    //         Start with the habits and actions that move you forward.
    //       </p>

    //       <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-3">
    //         {startPoints.map(({ id, title, desc, Icon }) => (
    //           <div
    //             key={id}
    //             className="bg-gray-50 border border-gray-200 rounded p-3 flex items-start"
    //           >
    //             <div className="mt-0.5">
    //               <Icon className="h-6 w-6 text-orange-600" />
    //             </div>
    //             <div className="ml-3">
    //               <p className="text-xs font-bold text-gray-700">{title}</p>
    //               <p className="text-xs text-gray-600 mt-1">{desc}</p>
    //             </div>
    //           </div>
    //         ))}
    //       </div>
    //     </div>
    //   );
    // }

    // 31 Mar 2026
    if (selectedSection === "unlockSelf") {
      return <EtTrinityOnboardingUnlockSelf />
    }

    // if (selectedSection === "unlockSelf") {
    //   return (
    //     <div>
    //       <p className="text-sm font-bold text-gray-800">Unlock Yourself</p>
    //       <p className="text-xs text-gray-600 mt-1">
    //         Each part of Trinity strengthens a different dimension of you.
    //       </p>

    //       <div className="mt-3 space-y-2">
    //         {unlockYourself.map(({ id, unlock, area, Icon }) => (
    //           <div
    //             key={id}
    //             className="bg-gray-50 border border-gray-200 rounded p-3 flex items-center justify-between"
    //           >
    //             <div className="flex items-center">
    //               <Icon className="h-6 w-6 text-orange-600" />
    //               <div className="ml-3">
    //                 <p className="text-xs font-bold text-gray-700">{unlock}</p>
    //                 <p className="text-xs text-gray-500 mt-1">{area}</p>
    //               </div>
    //             </div>

    //             <ArrowRightIcon className="h-4 w-4 text-gray-400" />
    //           </div>
    //         ))}
    //       </div>
    //     </div>
    //   );
    // }

    // 15 Apr 2026
    if (selectedSection === "unlockTeams") {
      return <EtTrinityOnboardingUnlockTeams />
    }

    // 20 Apr 2026
    if (selectedSection === "unlockBIC") {
      return <EtTrinityOnboardingUnlockBIC />
    }

    
    // if (selectedSection === "unlockTeams") {
    //   return (
    //     <div>
    //       <p className="text-sm font-bold text-gray-800">Unlock Your Teams</p>
    //       <p className="text-xs text-gray-600 mt-1">
    //         Your growth can influence how your team and organization grow together.
    //       </p>

    //       <div className="mt-3 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
    //         {unlockYourTeams.map(({ id, title, desc, Icon }) => (
    //           <div
    //             key={id}
    //             className="bg-gray-50 border border-gray-200 rounded p-3"
    //           >
    //             <div className="flex items-center">
    //               <Icon className="h-6 w-6 text-orange-600" />
    //               <p className="text-xs font-bold text-gray-700 ml-2">{title}</p>
    //             </div>
    //             <p className="text-xs text-gray-600 mt-2">{desc}</p>
    //           </div>
    //         ))}
    //       </div>
    //     </div>
    //   );
    // }

    // if (selectedSection === "boardView") {        // 20 Apr 2026
    // if (selectedSection === "unlockBIC") {
    //   return (
    //     <div>
    //       <p className="text-sm font-bold text-gray-800">See Where You Stand</p>
    //       <p className="text-xs text-gray-600 mt-1">
    //         The Purpose Native Board helps you see what you have unlocked so far and what to build next.
    //       </p>

    //       <div className="mt-3 flex flex-wrap items-center gap-2">
    //         <div className="flex items-center px-3 py-2 rounded-full bg-gray-50 border border-gray-200">
    //           <UserIcon className="h-6 w-6 text-orange-600" />
    //           <span className="text-xs font-bold text-gray-700 ml-2">Self</span>
    //         </div>

    //         <div className="flex items-center px-3 py-2 rounded-full bg-gray-50 border border-gray-200">
    //           <UsersIcon className="h-6 w-6 text-orange-600" />
    //           <span className="text-xs font-bold text-gray-700 ml-2">Collective</span>
    //         </div>

    //         <div className="flex items-center px-3 py-2 rounded-full bg-gray-50 border border-gray-200">
    //           <GlobeAltIcon className="h-6 w-6 text-orange-600" />
    //           <span className="text-xs font-bold text-gray-700 ml-2">Universe</span>
    //         </div>
    //       </div>

    //       <div className="mt-3 bg-gray-50 border border-gray-200 rounded p-3">
    //         <p className="text-xs text-gray-600">
    //           Your progress is shaped by what you practice across Trinity.
    //         </p>
    //       </div>
    //     </div>
    //   );
    // }

    return null;
  };

  return (
    <div className="mt-2 space-y-3">

      {/* 1️⃣ WEB VIEW */}
      {!isMobileView && (
        <>
          {/* Section cards */}
          <div className="grid grid-cols-1 md:grid-cols-5 xl:grid-cols-5 gap-3">
            {onboardingSections.map(({ id, title, desc, Icon }) => (
              <div
                key={id}
                onClick={() => setSelectedSection(id)}
                className={`rounded border p-3 cursor-pointer shadow-sm transition ${
                  selectedSection === id
                  ? "bg-gradient-to-r from-orange-600 to-orange-600 via-orange-800 text-white hover:bg-gradient-to-r hover:from-orange-400 hover:via-orange-600 hover:to-orange-900 shadow-lg shadow-gray-800"
              : "bg-gray-100 shadow"
                    // ? "bg-black text-orange-600 border-black"
                    // : "bg-white text-gray-700 border-gray-200 hover:bg-gray-50"
                }`}
              >
                <div className="flex items-center">
                  <Icon className={`h-8 w-8 ${
                  selectedSection === id ? "": "text-orange-600"}`} />
                </div>

                <div className="mt-3">
                  <p className={`text-xs font-bold ${
                  selectedSection === id ? "font-bold tracking-widest uppercase": ""}`}>{title}</p>
                  <p
                    className={`text-xs mt-1 ${
                      selectedSection === id ? "text-white" : "text-gray-800"
                    }`}
                  >
                    {desc}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Detail panel */}
          <div className="bg-white rounded shadow-sm border p-4">
            {renderSectionContent()}
          </div>

        </>
      )}

      {/* 2️⃣ MOBILE VIEW */}
      {isMobileView && (
        <>
          {/* Welcome */}
          <div className="bg-white rounded shadow-sm border p-4">
            <div
              className="flex items-center justify-start cursor-pointer"
              onClick={() => toggleSection("welcome")}
            >
              {openSections.welcome ? (
                <MinusIcon className="h-5 w-5 text-orange-600" />
              ) : (
                <PlusIcon className="h-5 w-5 text-orange-600" />
              )}

              <EtEtTrinityIcon6SVGComp className="h-6 w-6 text-orange-600 mx-2" />

              <div className="mx-2 px-2">
                <p className="text-sm font-bold text-gray-800">Welcome to Trinity</p>
                <p className="text-xs text-gray-600 mt-1">
                  Build visible growth through what you practice every day.
                </p>
              </div>
            </div>

            {openSections.welcome && (
              <div className="mt-3">
                <EtTrinityOnboardingWelcomeContent />
              </div>
            )}
          </div>

          {/* Where to Begin */}
          <div className="bg-white rounded shadow-sm border p-4">
            <div
              className="flex items-center justify-start cursor-pointer"
              onClick={() => toggleSection("begin")}
            >
              {openSections.begin ? (
                <MinusIcon className="h-5 w-5 text-orange-600" />
              ) : (
                <PlusIcon className="h-5 w-5 text-orange-600" />
              )}

              <EtStartHereIconSVGComp className="h-6 w-6 text-orange-600 mx-2" />

              <div className="mx-2 px-2">
                <p className="text-sm font-bold text-gray-800">Where to Begin</p>
                <p className="text-xs text-gray-600 mt-1">
                  Start with the habits and actions that move you forward.
                </p>
              </div>
            </div>

            {openSections.begin && (
              <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-3">
                {startPoints.map(({ id, title, desc, Icon }) => (
                  <div
                    key={id}
                    className="bg-gray-50 border border-gray-200 rounded p-3 flex items-start"
                  >
                    <div className="mt-0.5">
                      <Icon className="h-6 w-6 text-orange-600" />
                    </div>
                    <div className="ml-3">
                      <p className="text-xs font-bold text-gray-700">{title}</p>
                      <p className="text-xs text-gray-600 mt-1">{desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Unlock Yourself */}
          <div className="bg-white rounded shadow-sm border p-4">
            <div
              className="flex items-center justify-start cursor-pointer"
              onClick={() => toggleSection("unlockSelf")}
            >
              {openSections.unlockSelf ? (
                <MinusIcon className="h-5 w-5 text-orange-600" />
              ) : (
                <PlusIcon className="h-5 w-5 text-orange-600" />
              )}

              <UserIcon className="h-6 w-6 text-orange-600 mx-2" />

              <div className="mx-2 px-2">
                <p className="text-sm font-bold text-gray-800">Unlock Yourself</p>
                <p className="text-xs text-gray-600 mt-1">
                  Each part of Trinity strengthens a different dimension of you.
                </p>
              </div>
            </div>

            {openSections.unlockSelf && (
              <div className="mt-3">
                <EtTrinityOnboardingUnlockSelf />
              </div>
            )}
          </div>

          {/* Unlock Your Teams */}
          <div className="bg-white rounded shadow-sm border p-4">
            <div
              className="flex items-center justify-start cursor-pointer"
              onClick={() => toggleSection("unlockTeams")}
            >
              {openSections.unlockTeams ? (
                <MinusIcon className="h-5 w-5 text-orange-600" />
              ) : (
                <PlusIcon className="h-5 w-5 text-orange-600" />
              )}

              <UsersIcon className="h-7 w-7 text-orange-600 mx-2" />

              <div className="mx-2 px-2">
                <p className="text-sm font-bold text-gray-800">Unlock Your Teams</p>
                <p className="text-xs text-gray-600 mt-1">
                  Your growth can influence how your team and organization grow together.
                </p>
              </div>
            </div>

            {openSections.unlockTeams && (

              <div className="mt-3">
                <EtTrinityOnboardingUnlockTeams />
              </div>

              // <div className="mt-3 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
              //   {unlockYourTeams.map(({ id, title, desc, Icon }) => (
              //     <div
              //       key={id}
              //       className="bg-gray-50 border border-gray-200 rounded p-3"
              //     >
              //       <div className="flex items-center">
              //         <Icon className="h-6 w-6 text-orange-600" />
              //         <p className="text-xs font-bold text-gray-700 ml-2">{title}</p>
              //       </div>
              //       <p className="text-xs text-gray-600 mt-2">{desc}</p>
              //     </div>
              //   ))}
              // </div>
            )}
          </div>

          {/* See Where You Stand */}
          <div className="bg-white rounded shadow-sm border p-4">
            <div
              className="flex items-center justify-start cursor-pointer"
              onClick={() => toggleSection("boardView")}
            >
              {openSections.boardView ? (
                <MinusIcon className="h-5 w-5 text-orange-600" />
              ) : (
                <PlusIcon className="h-5 w-5 text-orange-600" />
              )}

              <GlobeAltIcon className="h-8 w-8 text-orange-600 mx-2" />

              <div className="mx-2 px-2">
                <p className="text-sm font-bold text-gray-800">See Where You Stand</p>
                <p className="text-xs text-gray-600 mt-1">
                  The Purpose Native Board helps you see what you have unlocked so far and what to build next.
                </p>
              </div>
            </div>

            {openSections.boardView && (
              <>
                <div className="mt-3 flex flex-wrap items-center gap-2">
                  <div className="flex items-center px-3 py-2 rounded-full bg-gray-50 border border-gray-200">
                    <UserIcon className="h-4 w-4 text-orange-600" />
                    <span className="text-xs font-bold text-gray-700 ml-2">Self</span>
                  </div>

                  <div className="flex items-center px-3 py-2 rounded-full bg-gray-50 border border-gray-200">
                    <UsersIcon className="h-4 w-4 text-orange-600" />
                    <span className="text-xs font-bold text-gray-700 ml-2">Collective</span>
                  </div>

                  <div className="flex items-center px-3 py-2 rounded-full bg-gray-50 border border-gray-200">
                    <GlobeAltIcon className="h-4 w-4 text-orange-600" />
                    <span className="text-xs font-bold text-gray-700 ml-2">Universe</span>
                  </div>
                </div>

                <div className="mt-3 bg-gray-50 border border-gray-200 rounded p-3">
                  <p className="text-xs text-gray-600">
                    Your progress is shaped by what you practice across Trinity.
                  </p>
                </div>
              </>
            )}
          </div>

        </>
      )}
    </div>
  );
};

export default EtTrinityPurposeNativeOnBoarding;